export default __webpack_public_path__ + "a845a1790298985f6f18be88dc418360.jpg";